import React from 'react';
import styled, { keyframes } from 'styled-components';

// Animations
const slideIn = keyframes`
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-10px);
    opacity: 0;
  }
`;

// Styled Components
const ChipContainer = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 20px;
  right: 28px;
  z-index: 60;
  user-select: none;
  animation: ${props => props.$isVisible ? slideIn : slideOut} 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 9999px;
  background: #f3e8ff;
  color: #7c3aed;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #e9d5ff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const ChipDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #a855f7;
`;

// Types
interface FloatingStatusChipProps {
  isVisible: boolean;
  children: React.ReactNode;
}

// Component
export const FloatingStatusChip: React.FC<FloatingStatusChipProps> = ({ isVisible, children }) => {
  if (!isVisible) return null;

  return (
    <ChipContainer $isVisible={isVisible}>
      <Chip>
        <ChipDot />
        {children}
      </Chip>
    </ChipContainer>
  );
};
